class LibertasFaq extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.searchInput = this.querySelector('[data-faq-search]');
    this.items = [...this.querySelectorAll('[data-faq-item]')];
    this.emptyState = this.querySelector('[data-faq-empty]');
    this.status = this.querySelector('[data-faq-status]');
    this.activeCategory = 'all';

    this.addEventListener('click', (event) => {
      const categoryButton = event.target.closest('[data-faq-category]');
      if (!categoryButton) return;
      this.activeCategory = categoryButton.dataset.faqCategory;
      this.querySelectorAll('[data-faq-category]').forEach((button) => {
        const active = button.dataset.faqCategory === this.activeCategory;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      this.applyFilters();
    });

    this.searchInput?.addEventListener('input', () => this.applyFilters());
    this.applyFilters();
  }

  applyFilters() {
    const searchTerm = this.normalize(this.searchInput?.value || '');
    let visibleCount = 0;

    this.items.forEach((item) => {
      const matchesCategory =
        this.activeCategory === 'all' || item.dataset.category === this.activeCategory;
      const matchesSearch = !searchTerm || this.normalize(item.dataset.search).includes(searchTerm);
      const visible = matchesCategory && matchesSearch;
      item.hidden = !visible;
      if (!visible) item.removeAttribute('open');
      if (visible) visibleCount += 1;
    });

    if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
    if (this.status) {
      this.status.textContent =
        visibleCount === 1
          ? '1 pregunta encontrada'
          : `${visibleCount} preguntas encontradas`;
    }
  }

  normalize(value) {
    return String(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }
}

if (!customElements.get('libertas-faq')) customElements.define('libertas-faq', LibertasFaq);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('libertas-faq').forEach((element) => element.connectedCallback());
});
